import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}booking/`,
  [],
  [authentication],
  [],
  false,
  3 * 60 * 1000,
  true,
);

export default {

  /**
   * @param bookingId
   * @returns {AxiosPromise}
   */
  getBookingWithCustomerAndStaysByBookingId(bookingId) {
    return conduit.get(`${bookingId}/with-customer-and-booking-stays`);
  },

  /**
   * @param bookingStayIds
   * @returns {AxiosPromise}
   */
  getBookingStayParticipantsByStayIds(bookingStayIds) {
    return conduit.post('participants/by-booking-stay-ids', {
      bookingStayIds,
    });
  },

  getPickupPlaces(payload) {
    const url = payload.skiRental ? `${payload.bookingId}/skirental/pickup` : `${payload.bookingId}/skipass/pickup`;
    return conduit.get(url);
  },

  savePickupPlaces(payload) {
    const url = payload.skiRental ? `${payload.bookingId}/skirental/pickup` : `${payload.bookingId}/skipass/pickup`;
    return conduit.put(url, payload.id);
  },
};



// WEBPACK FOOTER //
// ./src/services/booking-service.js